import { Controller } from "@hotwired/stimulus"

// Navigate to a URL when this element connects — used to auto-advance the application
// "reading…" page to the prefilled lead form once the extraction finishes (the status
// panel is swapped in via a Turbo broadcast, which fires connect()). A visible link is
// always rendered alongside as a manual fallback.
export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 400 } }

  connect() {
    if (!this.urlValue) return
    this.timer = setTimeout(() => { window.location = this.urlValue }, this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }
}
